<app-tab-grid
  i18n-name
  name="Sales Order History"
  [columnDefs]="columnDefs"
  [fields]="fields"
  [model]="model"
  [rowData]="model$ | async"
  [showCreate]="false"
  [showDelete]="false"
></app-tab-grid>
